import { FunctionComponent, ReactNode } from "react";
import { Combobox, ComboboxOption } from "@headlessui/react";
import { cn } from "../../../utils/cn";

export interface SelectOptionProps {
  className?: string;
  value: any;
  children: ReactNode;
}

interface OptionState {
  active: boolean;
  selected: boolean;
  disabled: boolean;
}
const variants = {
  full({ active, selected }: OptionState) {
    return cn(
      " px-4 ",
      active ? "bg-teal-600 text-white" : "text-gray-900",
      selected && !active && "bg-gray-100",
    );
  },
};
/**
 *
 */
export const SelectOption: FunctionComponent<SelectOptionProps> = ({
  className,
  value,
  children,
}) => {
  const css = function ({
    active,
    selected,
    disabled,
  }: {
    active: boolean;
    selected: boolean;
    disabled: boolean;
  }) {
    return cn(
      className,
      "relative cursor-default select-none py-2 ",
      variants.full({ active, selected, disabled }),
    );
  };
  return (
    <ComboboxOption className={css} key={value.id} value={value}>
      {({ selected }) => (
        <span
          className={`block truncate ${
            selected ? "font-semibold" : "font-normal"
          }`}
        >
          {children}
        </span>
      )}
    </ComboboxOption>
  );
};
